import React, { PureComponent } from 'react';

import DateBox from 'devextreme-react/date-box';

import CoreUtils from '../utils/CoreUtils';
import DateTimeUtils from '../utils/DateTimeUtils';

export default class DateEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onControlValueListener = this.onControlValueChanged.bind(this);
  }

  render() {
    return (
      <DateBox
        title={this.props.tooltip || ''}
        className="pwx-date-editor"
        acceptCustomValue={false}
        disabled={this.props.disabled}
        displayFormat={value => DateTimeUtils.formatShortDate(value)}
        format="date"
        height={this.props.height}
        name={this.props.name}
        onValueChanged={this.onControlValueListener}
        value={this.props.value}
        width={this.props.width}
      />
    );
  }

  onControlValueChanged(event) {
    var value = event.value;
    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      value = this.props.postEditFilter(value);

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}